import { NgModule } from "@angular/core";
import { TopBarComponent } from "./components/top-bar/top-bar.component";
import { LeftMenuAdminComponent } from './components/left-menu-admin/left-menu-admin.component';
import { RouterModule } from '@angular/router';
import { MainSharedRoutingModule } from "./main-shared-routing.module";
import { ErrorMessageComponent } from './components/error-message/error-message.component';
import { CommonPrimeNgModule } from "../main-shared/common-prime-ng.module";
import { CommonModule } from "@angular/common";
import { EquipmentStatusDetailsComponent } from "./components/equipment-status-details/equipment-status-details.component";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CardModule, } from 'primeng/card';
import { GisMiniMapComponent } from './components/gis-mini-map/gis-mini-map.component';
import { MyProfileComponent } from "./components/my-profile/my-profile.component";
import { DialogNotificationDyComponent } from "./components/dialog-notification-dy/dialog-notification-dy.component";
import { DateAgoPipe } from "./pipes/date-ago.pipe";
import { FooterMineNxtComponent } from "./components/footer-mine-nxt/footer-mine-nxt.component";
import { ChangePasswordComponent } from "./components/change-password/change-password.component";
import { DirectiveModuleModule } from "../directive-module/directive-module.module";
import { MaxValueDirective } from "./directives/setInputMaxAttribute";




@NgModule({
    declarations: [TopBarComponent, LeftMenuAdminComponent, ErrorMessageComponent, EquipmentStatusDetailsComponent, GisMiniMapComponent, MyProfileComponent, DialogNotificationDyComponent, DateAgoPipe, FooterMineNxtComponent, ChangePasswordComponent, MaxValueDirective],
    imports: [MainSharedRoutingModule, CardModule, CommonPrimeNgModule, CommonModule, FormsModule, ReactiveFormsModule, DirectiveModuleModule],
    exports: [TopBarComponent, LeftMenuAdminComponent, RouterModule, ErrorMessageComponent, EquipmentStatusDetailsComponent, GisMiniMapComponent, MyProfileComponent, FooterMineNxtComponent, ChangePasswordComponent, MaxValueDirective],

})
export class MainSharedModule { }